import { useCallback, useEffect, useState } from "react";

import { useListBuilder } from "../../../context/ListBuilderContext/ListBuilderContext";

import ListBuilderView from "./ListBuilderView/ListBuilderView";
import FormSettings from "../FormBuilder/FormSettings/FormSettings";
import IntlMessages from "../../../util/IntlMessages";
import FormPreview from "../FormBuilder/FormPreview/FormPreview";
import FormsList from "../FormBuilder/FormsList/FormsList";

import "../../Widgets/FormBuilder/FormBuilder.less";

interface ListBuilderControllerInterface {}

const ListBuilderController: React.FC<ListBuilderControllerInterface> = ({}) => {
   const [isModalOpen, setIsModalOpen] = useState(false);

   const { setCurrentTab, currentTab } = useListBuilder();

   useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const tab = params.get("tab");
      if (tab === "formbuilder") {
         setCurrentTab(2);
      }
   }, []);

   const handleTabChange = useCallback((tab) => {
      setCurrentTab(tab);
   }, []);

   return (
      <>
         <button
            style={{ marginLeft: "1.1rem" }}
            className={`list-builder-tab-button ${currentTab === 1 ? "active" : ""}`}
            onClick={() => handleTabChange(1)}
         >
            <IntlMessages id="ListBuilder" />
         </button>
         <button
            className={`list-builder-tab-button ${currentTab === 2 ? "active" : ""}`}
            onClick={() => handleTabChange(2)}
         >
            <IntlMessages id="FormBuilder" />
         </button>
         {currentTab === 1 ? (
            <ListBuilderView />
         ) : (
            <div style={{ overflow: "scroll", maxHeight: "100%" }}>
               <FormSettings setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
               <div className="form-builder-wrapper">
                  <FormPreview />
               </div>
               <div className="form-list-wrapper">
                  <FormsList />
               </div>
            </div>
         )}
      </>
   );
};

export default ListBuilderController;
